package com.evoapps.evoshift.settings

import kotlinx.browser.localStorage
import kotlinx.browser.window
import org.w3c.dom.url.URLSearchParams

/**
 * localStorage, which can be missing or throw (private windows, blocked storage): then nothing is
 * remembered. The app language is the key the product site uses too ("lang", site-i18n.js), so
 * the app opens in the language picked on the site; a ?lang= in the address comes first.
 */
actual fun platformLocalSettings(): LocalSettings = object : LocalSettings {
    private fun storageKey(key: String) = if (key == AppLanguageSettings.KEY) "lang" else "evoshift.$key"

    override fun getString(key: String): String? {
        if (key == AppLanguageSettings.KEY) {
            URLSearchParams(window.location.search).get("lang")?.let { return it }
        }
        return runCatching { localStorage.getItem(storageKey(key)) }.getOrNull()
    }

    override fun putString(key: String, value: String?) {
        runCatching { if (value == null) localStorage.removeItem(storageKey(key)) else localStorage.setItem(storageKey(key), value) }
    }
}
